export default __webpack_public_path__ + "assets/isleofman-flag.png";